import { message } from 'antd';
import { DeliveryService } from '../../components/Pages/Orders/Adapter/enums';
import { ClientDataGood, ClientDataPackages } from '../../components/Pages/Orders/Adapter';
import { DeliveryServiceType } from '../../hooks/api/tracking';

/** Prevent from extra update if error in fedex form */
export function shouldContinueFedexUpdate(
  deliveryService: DeliveryServiceType,
  goods: ClientDataGood[] | undefined,
  packages: ClientDataPackages[] | undefined,
) {
  if (deliveryService === DeliveryService.FEDEX) {
    // If goods array is missing or empty, we can proceed. The check is only for items *in* the array.
    if (!goods || goods.length === 0) {
      return true;
    }

    /** Packages validation ---> */
    const hasPackages = Array.isArray(packages) && packages.length > 0;

    // Build list of goods IDs not present in any package (only when packages exist)
    const goodsNotInPackages = hasPackages
      ? goods.filter(
        (g) => !packages?.some((pkg) => pkg.items.some((item) => item.goodsItem.id === g.id)),
      )
      : goods;

    const goodsNotInPackagesIds = hasPackages
      ? goodsNotInPackages.map((g) => g?.id).filter(Boolean)
      : [];

    // If there are packages, validate that each has length, width, height > 0
    if (hasPackages) {
      const isAnyPackageDimInvalid = packages?.some(
        (pkg) => pkg.length === 0
          || pkg.length <= 0
          || !pkg.width
          || pkg.width <= 0
          || !pkg.height
          || pkg.height <= 0,
      );

      if (isAnyPackageDimInvalid) {
        message.error(
          'To update an invoice with the "FedEx" service, every package must have a valid length, width, and height!',
          20,
        );

        return false;
      }
    }
    /** Packages validation <--- */

    // Check if any item in the goods array has a volume that is not a positive number.
    // goods.some
    const isAnyVolumeInvalid = goodsNotInPackages.some((item) => !item.volume || item.volume <= 0);
    const isAnyGrossInvalid = goods.some((item) => !item.gross || item.gross <= 0);
    const isAnyNetInvalid = goods.some((item) => !item.net || item.net <= 0);
    const isNumberOfPacksInvalid = goods.some((item) => !item.quantity || item.quantity <= 0);

    if (isAnyVolumeInvalid || isAnyGrossInvalid || isAnyNetInvalid || isNumberOfPacksInvalid) {
      message.error(
        'To update an invoice with the "FedEx" service, you must fill in a valid volume, '
        + `gross and net for each goods item!${
          hasPackages
            ? `\n(Skipped validation for goods in packages: ${goodsNotInPackagesIds.join(
              ', ',
            )})`
            : ''}`,
        20,
      );

      return false; // Stop the process
    }
  }

  return true; // Continue the process
}

export default {
  shouldContinueFedexUpdate,
};
